<template>
  <v-dialog
    v-model="dialog"
    :width="notAttached? '1000px': '328px'">
    <div class="dialog-container">
      <h2>Attach Policy</h2>
      <section v-if="notAttached">
        <div class="abs-top-right">
          <v-button @click="dialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="handlerSave">Attach</v-button>
        </div>
        <div class="filter-container">
          <div class="flex">
            <div class="filter-box">
              <span class="label">Search</span>
              <div class="search-box">
                <v-input
                  v-model="search"
                  placeholder="Policy No., Customer Name, Insurer, Referrer or Price"
                  @keyEnter="filterData" />
              </div>
            </div>
            <div class="filter-box">
              <span class="label">Issue Date</span>
              <div class="search-box">
                <v-date-picker
                  v-model="date"
                  type="daterange"
                  @change="filterData" />
              </div>
            </div>
          </div>

          <div class="filter-box">
            <span class="label">
              Product Type
              <span
                class="all"
                @click="handlerSelectAll('product_id')">Select All</span>
            </span>
            <v-checkbox-group
              v-model="product_id"
              :list="productTypeOptions"
              @change="filterData"></v-checkbox-group>
          </div>
          <div class="filter-box">
            <span class="label">
              Insurer
              <span
                class="all"
                @click="handlerSelectAll('company_id')">Select All</span>
            </span>
            <v-checkbox-group
              v-model="company_id"
              :list="insurerOptions"
              @change="filterData"></v-checkbox-group>
          </div>
          <div class="filter-box">
            <span class="label">
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">Select All</span>
            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              @change="filterData"></v-checkbox-group>
          </div>
        </div>
        <!-- <div class="transparent"> -->
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          @row-click="rowClick">
          <el-table-column width="55">
            <template slot-scope="scope">
              <span
                :class="[
                  (selectIndex == scope.$index)? 'radio-circle-checked': 'radio-circle' 
                ]"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="issue_dt"
            label="Issue Date & Time"></el-table-column>
          <el-table-column
            prop="id"
            label="ID"></el-table-column>
          <el-table-column
            prop="product_type"
            label="Product Type"></el-table-column>
          <el-table-column
            prop="insurer"
            label="Insurer"></el-table-column>
          <el-table-column
            prop="policy_holder"
            label="Policyholder"></el-table-column>
          <el-table-column
            prop="contact_nm"
            label="Contact Name"></el-table-column>
          <el-table-column
            prop="phone_no"
            label="Phone No."></el-table-column>
          <el-table-column
            prop="policy_period"
            label="Policy Period"></el-table-column> 
          <el-table-column
            prop="stts"
            label="Status"></el-table-column>
          <el-table-column
            prop="tickets"
            label="Tickets"></el-table-column>
          <el-table-column width="55">
            <template slot-scope="scope">
              <v-button
                type="text"
                :stop="true"
                @click="handlerView(scope.row)">View</v-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- </div> -->

        <v-pagination
          :total="pageConfig.total"
          :current="pageConfig.currentPage"
          @currentChange="currentChange"
        />
      </section>
      <section v-else>
        <p>The selected policy has been attached.</p>
        <div class="dialog-footer">
          <v-button
            type="primary"
            @click="handlerDone">Done</v-button>
        </div>
      </section>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { getPolicyList } from '@/api/policy'
import { chooseTicketPolicy } from '@/api/ticket'
import { getAccountPolicyList } from '@/api/account'
export default {
  name: 'AttachPolicy',
  mixins: [MixinOptions],
  props: {
    ticketId: [String, Number],
    customerId:{
      type:Number,
      default:0
    },
    policyId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      notAttached: true,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      statusOptions: [
        {
          name: 'In Force',
          id: 1
        },
        {
          name: 'Expired',
          id: 2
        },
        {
          name: 'Cancelled',
          id: 3
        }
      ],
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: [],
      selectIndex: -1
    }
  },
  watch: {
    customerId: {
      immediate: true,
      handler(val) {
        if(val!=0)
          this.network().getAccountPolicyList()
        else
          this.network().getPolicyList()
      }
    },
    policyId: {
      immediate: true,
      handler(id) {
        this.tableData.some((item, index) => {
          if(item.id == this.policyId) {
            this.selectIndex = index
            return true
          }
        })
      }
    },
    tableData: {
      immediate: true,
      deep: true,
      handler(data) {
        data.some((item, index) => {
          if(item.id == this.policyId) {
            this.selectIndex = index
            return true
          }
        })
      }
    }
  },
  
  methods: {
    handlerSave() {
      const { tickets } = this.tableData[this.selectIndex]
      if(tickets ) {
        this.notAttached = false
        return
      }
      if(this.selectIndex !== -1) {
        this.network().chooseTicketPolicy()
      }
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productTypeOptions'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    handlerView(row) {
      const { id, product_id, pcy_id } = row
      this.$router.push({
        path: product_id > 50? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          pcy_id,
          product_id
        }
      })
    },
    rowClick(row) {
      const { index } = row
      this.selectIndex = index
    },
    filterData() {
      this.pageConfig.currentPage = 1
      if(this.customerId!=0)
        this.network().getAccountPolicyList()
      else
        this.network().getPolicyList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      if(this.customerId!=0)
        this.network().getAccountPolicyList()
      else
        this.network().getPolicyList()
    },
    handlerDone() {
      this.notAttached = true
      this.dialog = false
    },
    network() {
      return {
        getPolicyList: async () => {
          let { data } = await getPolicyList({
            pcy_cmnt_dt: this.date[0],
            pcy_expry_dt: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            hideLoading: true,
          })
          data.data.map((item, index) => {
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.selectIndex = -1
        },
        chooseTicketPolicy: async () => {
          const { data } = await chooseTicketPolicy({
            ticket_id: this.ticketId,
            order_id: this.tableData[this.selectIndex].id
          })
          // 更新数据
          this.pageConfig.currentPage = 1
          if(this.customerId!=0)
            this.network().getAccountPolicyList()
          else
            this.network().getPolicyList()

          this.dialog = false
          this.$emit('success')
        },
        getAccountPolicyList:async () =>{
          let { data } = await getAccountPolicyList({
            pcy_cmnt_dt: this.date[0],
            pcy_expry_dt: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            hideLoading: true,
            customer_id: this.customerId
          })
          data.data.map((item, index) => {
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.selectIndex = -1
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    position: relative;
  padding: 15px;
  .abs-top-right {
      padding: 20px 15px;
  }
   p {
    padding-bottom: 15px;
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .filter-container {
     .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>